<template>
  <div>
    <div class="top-box" @click="iconClick">
        <img :src="imgUrls.url" alt="" class="imgsa">
        <div class="use-title-box">
            <div class="use-d2">
            <van-row style="padding: 10px 3%;" gutter="20">
                <van-col style="display: flex;" class="van-col-title" span="12">
                    <!-- // userImage -->
                    <img class="use-img" v-if="userData.imageSrc == '' || userData.imageSrc == null" src="../../assets/image/userImage.png" alt="">
                    <img class="use-img" v-else :src="userData.imageSrc" alt="">
                </van-col>
            </van-row>
            </div>
            <div class="use-d1">
            <van-row style="padding-left: 8%;" >
                <van-col class="van-col-titles" span="24">
                    <div class="use-size">{{userData.userName}}</div>
                </van-col>
            </van-row>
            <van-row style="padding-left: 9%;padding-top: 5px;" >
                <van-col style="color:#fff;z-index: 10;display: flex;"  class="van-col-title" span="24">
                    <div style="z-index: 10;">{{userData.businessName}}</div>
                </van-col>
            </van-row>
            </div>
            <div class="use-d3">
                <van-icon  size="24px" color="#fff" name="arrow" />
            </div>
        </div>
    </div>
    <div v-if="userData.auditStatus == 0"    @click="gotoAuth" style="display: flex; justify-content: center; align-items: center; ">
        <img  style="width: 90%; " src="../../assets/image/inviteAuth.png" alt="">
    </div>
    <div class="d-box" v-else>
    </div>
    
    <van-row>
        <van-col span=""></van-col>
    </van-row>
    <van-cell @click="collectClick" is-link>
        <!-- 使用 title 插槽来自定义标题 -->
        
        <template #icon>
            <div class="box">
                <img class="collect-img-style" src="../../assets/image/collect.png" alt="">
            </div>
        </template>
        <template #title>
            <span class="custom-title">我的收藏</span>
        </template>
    </van-cell>
    <van-cell @click="recipeClick" is-link icon="shop-o">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #icon>
            <div class="box">
                <img class="collect-img-style" src="../../assets/image/我的配方.png" alt="">
            </div>
        </template>
        <template #title>
            <span class="custom-title">我的配方</span>
        </template>
    </van-cell>
    <van-cell @click="myRecipeHistory" is-link icon="shop-o">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #icon>
            <div class="box">
                <img class="collect-img-style" src="../../assets/image/history.png" alt="">
            </div>
        </template>
        <template #title>
            <span class="custom-title">历史记录</span>
        </template>
    </van-cell>
    <van-cell @click="integralClick" is-link :value="pointBalance" icon="shop-o">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #icon>
            <div class="box">
                <img class="collect-img-style" src="../../assets/image/我的积分.png" alt="">
            </div>
        </template>
        <template #title>
            <span class="custom-title">我的积分</span>
        </template>
    </van-cell>
    <!-- 问题反馈注释 -->
    <van-cell @click="feedbackClick" is-link icon="shop-o">
        <template #icon>
            <div class="box">
                <img class="collect-img-style" src="../../assets/image/feedback.png" alt="">
            </div>
        </template>
        <template #title>
            <span class="custom-title">问题反馈</span>
        </template>
    </van-cell>
     <!-- 邀请码 -->
     <van-cell @click="inviteCodeGener" is-link icon="shop-o"  v-if="userData.inviteCodeEnabled == 1">
        <template #icon>
            <div class="box">
                <img class="collect-img-style" src="../../assets/image/invite.png" alt="">
            </div>
        </template>
        <template #title>
            <span class="custom-title">邀请码</span>
        </template>
    </van-cell>
    <van-cell @click="pushSetting" is-link icon="shop-o">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #icon>
            <div class="box">
                <img class="collect-img-style" src="../../assets/image/设置.png" alt="">
            </div>
        </template>
        <template #title>
            <span class="custom-title">设置</span>
        </template>
    </van-cell>
    <Tabbar class="tab-style"  :key="datekey" ></Tabbar>  
  </div>
</template>

<script>
import Tabbar from "../../components/Tabbar.vue";
import Api from "../../api/api";
import { Toast,Dialog } from "vant";
export default {
    data() {
        return {
            datekey:Date.now(),  //，单独刷新 底部选择tab
            imgUrls:{ url: require("../../assets/image/myBack.png") },
            // 用户详情接口入参
            userIdData: {
                userId: null,
            },
            // 用户详情接口出参
            userData:{
                businessName: "",
                businessVersionType: null,
                imageSrc: null,
                phone: "",
                userId: null,
                userName: "",
                auditStatus: 1,
                inviteCodeEnabled: 0,

            }, 
            pointBalance: 0, // 用户积分
        }
    },
    components: { 
        Tabbar,
    },
    mounted() {
    
    
    },

    created() {
        this.userIdData.userId = localStorage.getItem("userId") 
        Api.info(this.userIdData).then((res) => {
            debugger
            this.userData = res.data.result;
            this.pointBalance = res.data.result.pointBalance;
        })
    },
    methods: {
        pushSetting() {
            if (window.HoLiObject) {
                window.HoLiObject.h5PushSetAction();
            } else {
                window.webkit.messageHandlers.HoLiObject.postMessage({
                method: "h5PushSetAction"
                });
            }
        },
        // 我的收藏
        collectClick() {
            console.log('收藏');

            let auditStatus=this.userData.auditStatus
            if(  auditStatus ==0 ) {  // 未审核用户 不运行使用搜索配方
                    Dialog.confirm({
                        title: '认证提示',
                        width: '80%',
                        message: '使用邀请码认证成功后，体验APP完整功能。',
                        confirmButtonText: '去认证',
                        confirmButtonColor: '#1989fa',
                        messageAlign: 'left',
                    }).then(() => {

                        this.$router.push({ path:'/app-h5-cn/page/myIniviteAuth' });
                    }).catch(() => {


                    });
            }else{
                this.$router.push('/app-h5-cn/page/myCollect');
            }


           
        },
        // 我的配方
        recipeClick(){
            let auditStatus=this.userData.auditStatus
            if( auditStatus ==0 ) {  // 未审核用户 不运行使用搜索配方
                Dialog.confirm({
                    title: '认证提示',
                    width: '80%',
                    message: '使用邀请码认证成功后，体验APP完整功能。',
                    confirmButtonText: '去认证',
                    confirmButtonColor: '#1989fa',
                    messageAlign: 'left',
                }).then(() => {

                    this.$router.push({ path:'/app-h5-cn/page/myIniviteAuth' });
                }).catch(() => {


                });
            }else{
                this.$router.push('/app-h5-cn/page/myRecipe');
            }
           
        },
         // 历史记录
        myRecipeHistory(){
            let auditStatus=this.userData.auditStatus
            if( auditStatus ==0 ) {  // 未审核用户 不运行使用搜索配方
                Dialog.confirm({
                    title: '认证提示',
                    width: '80%',
                    message: '使用邀请码认证成功后，体验APP完整功能。',
                    confirmButtonText: '去认证',
                    confirmButtonColor: '#1989fa',
                    messageAlign: 'left',
                }).then(() => {

                    this.$router.push({ path:'/app-h5-cn/page/myIniviteAuth' });
                }).catch(() => {


                });
            }else{
                this.$router.push('/app-h5-cn/page/myRecipeHistory');
            }
           
        },
        // 我的积分
        integralClick() {
            this.$router.push('/app-h5-cn/page/integral');
        },
        // 问题反馈
        feedbackClick() {
            this.$router.push('/app-h5-cn/page/feedbackList');
        },
        // 进入我的页面
        iconClick() {
            this.$router.push('/app-h5-cn/page/myInfo');
        },
        //进入生成邀请码页面
        inviteCodeGener(){
            this.$router.push('/app-h5-cn/page/myIniviteCode');
        },
        // 进入认证页面
        gotoAuth() {
            this.$router.push('/app-h5-cn/page/myIniviteAuth');
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 25px;
    height: 100%;
}
.top-box {
    width: 100%;
    height: 150px;
    
    // background-size: 100% 100%;
    // background-image:  url("../../assets/image/我的_背景图.png") no-repeat;
    .imgsa {
        position: absolute;
        width: 100%;
        height: 150px;
        // height: 100%;
        // z-index: -1;
    }
}
.d-box {
    height: 30px;
    width: 100%;
    // background-color: white;
}
.use-title-box {
    width: 100%;
    height: 100%;
    display: flex;
    z-index: 100 !important;
    // margin-bottom: 1px;
    // margin-top: 10px;
    // background-color: white;
   .use-d1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 67%;
    //  border: solid 1px red;
    .van-col-titles {
        display: flex;
        .use-size {
            color: #fff;
            font-size: 17px;
            font-weight: 600;
            z-index: 10;
        }
    }
   }
   .use-d2 {
      width: 70px;
      margin-left: 5%;
      display: flex;
      justify-content: center;
      align-items: center;
      .use-img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          z-index: 10;
      }
   } 
   .use-d3 {
    // width: 100%;
    // border: solid 1px red;
    z-index: 10;
    display: flex;
    align-items: center;
   }
}
.collect-img-style {
    width: 22px;
    height: 22px;
}
.collect-img-style {
    width: 17px;
    height: 17px;
}
.custom-title {
    margin-left: 10px;
}
/deep/ .van-col--12 {
    width: 100%;
}
.toastCss{
    width: 230px !important;
    font-size: 13px !important;
}
</style>